import { FormControlProps } from '../../interfaces/FormControlProps';

export class ParameterMappingsHelper {
    static hasParameterMappings(component: React.Component<FormControlProps>) {
        const formConfig = component.props.formConfig;
        const formFieldDefinition = component.props.formFieldDefinition;
        return (
            formConfig.parameterMappings !== undefined &&
            formConfig.parameterMappings[formFieldDefinition.triggerDatasource || formFieldDefinition.datasource] !== undefined
        );
    }

    static parameterMappings(
        component: React.Component<FormControlProps>,
        doPerItem = (item: any) => item
    ) {
        if (!this.hasParameterMappings(component)) {
            return [];
        }

        const formConfig = component.props.formConfig;
        const formFieldDefinition = component.props.formFieldDefinition;

        const mappings = formConfig.parameterMappings[formFieldDefinition.triggerDatasource || formFieldDefinition.datasource];

        return mappings.map(doPerItem);

    }

    static parameterMappingsViaDatasource(
        formConfig: any,
        datasource: string,
        doPerItem = (item: any) => item
    ) {
        if (formConfig.parameterMappings === undefined ||
            formConfig.parameterMappings[datasource] === undefined) {
            return [];
        }

        const mappings = formConfig.parameterMappings[datasource];

        return mappings.map(doPerItem);

    }
}
